import React, { useCallback } from 'react';
import { EuiFlexGroup, EuiFlexItem } from '@elastic/eui';
import EltRider from '../../../../components/settings/outlet-form/elt_rider';
import DunzoRider from '../../../../components/settings/outlet-form/dunzo_rider';
import WeFastRider from '../../../../components/settings/outlet-form/wefast_rider';
import PorterRider from '../../../../components/settings/outlet-form/porter_rider';
import ShadowFaxRiders from '../../../../components/settings/outlet-form/shadow_fax_rider';
import { FormProvider } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { outletSettingsAPI } from '../../../../api/outlet/outletSettingsAPI';
import FormGroupDescription from '../../../../components/formGroupDescription';
import ButtonGroup from '../../../../components/Form/ButtonGroup';
import useOutletFormValues from '../../Hooks/useOutletFormValues';
import useFormActionsHandler from '../../../../hooks/useFormActionsHandler';
import FlashRider from '../../../../components/settings/outlet-form/Flast_rider';
import HLDedicatedRider from '../../../../components/settings/outlet-form/HL_Dedicated_rider';
import BlitzRider from '../../../../components/settings/outlet-form/blitz_rider';
import BorzoRider from '../../../../components/settings/outlet-form/borzo_rider';
import EkBharatRider from '../../../../components/settings/outlet-form/ek_bharat_rider';
import LoadShareRider from '../../../../components/settings/outlet-form/load_share_rider';
import MagicPinRider from '../../../../components/settings/outlet-form/magicpin_rider';
import OndcRider from '../../../../components/settings/outlet-form/ondc_rider';
import QwqerRider from '../../../../components/settings/outlet-form/qwqer_rider';
import RapidoRider from '../../../../components/settings/outlet-form/rapido_rider';
import AdlogsShadowfaxRider from '../../../../components/settings/outlet-form/adlogs_shadowfax_rider';
import ShipRocketRider from '../../../../components/settings/outlet-form/ship_rocket_rider';
import YulluRider from '../../../../components/settings/outlet-form/yullu_rider';

const ThirdPartyRider = () => {
    const dispatch = useDispatch();
    const restaurantDescriptions = useSelector((state) => state.auth.restaurantDescriptions);

    const updateFormValues = useCallback((data) => {
        let defaultValue = {};

        defaultValue.enable_own_rider_service = data.settings.enable_own_rider_service;

        //WeFast rider info
        defaultValue.wefast_auth_token = data.third_party_rider_setting
            ? data.third_party_rider_setting.wefast_auth_token
            : '';
        defaultValue.wefast_call_back_url = data.third_party_rider_setting
            ? data.third_party_rider_setting.wefast_call_back_url
            : '';
        defaultValue.wefast_integration_available = data.third_party_rider_setting
            ? data.third_party_rider_setting.wefast_integration_available
                ? 1
                : 0
            : 0;

        //Dunzo Rider info
        defaultValue.dunzo_client_secret = data.third_party_rider_setting
            ? data.third_party_rider_setting.dunzo_client_secret
            : '';
        defaultValue.dunzo_client_id = data.third_party_rider_setting
            ? data.third_party_rider_setting.dunzo_client_id
            : '';
        defaultValue.dunzo_call_back_url = data.third_party_rider_setting
            ? data.third_party_rider_setting.dunzo_call_back_url
            : '';
        defaultValue.dunzo_integration_available = data.third_party_rider_setting
            ? data.third_party_rider_setting.dunzo_integration_available
                ? 1
                : 0
            : 0;

        //ELT rider info
        defaultValue.elt_api_key = data.third_party_rider_setting ? data.third_party_rider_setting.elt_api_key : '';
        defaultValue.elt_primary_address_id = data.third_party_rider_setting
            ? data.third_party_rider_setting.elt_primary_address_id
            : '';
        defaultValue.elt_call_back_url = data.third_party_rider_setting
            ? data.third_party_rider_setting.elt_call_back_url
            : '';
        defaultValue.elt_integration_available = data.third_party_rider_setting
            ? data.third_party_rider_setting.elt_integration_available
                ? 1
                : 0
            : 0;

        //porter
        defaultValue.porter_token = data.third_party_rider_setting ? data.third_party_rider_setting.porter_token : '';
        defaultValue.is_porter_integration_enabled = data.third_party_rider_setting
            ? data.third_party_rider_setting.is_porter_integration_enabled
                ? 1
                : 0
            : 0;
        // Flash
        defaultValue.flash_token = data.third_party_rider_setting ? data.third_party_rider_setting?.flash_token : '';
        defaultValue.flash_credits_key = data.third_party_rider_setting
            ? data.third_party_rider_setting.flash_credits_key
            : '';
        defaultValue.flash_store_brand_id = data.third_party_rider_setting
            ? data.third_party_rider_setting.flash_store_brand_id
            : '';
        defaultValue.is_flash_integration_enabled = data.third_party_rider_setting?.is_flash_integration_enabled
            ? data.third_party_rider_setting.is_flash_integration_enabled
                ? 1
                : 0
            : 0;
        defaultValue.use_global_flash_configurations = data?.third_party_rider_setting?.use_global_flash_configurations;
        // HL Dedicated
        defaultValue.hl_storebased_token = data.third_party_rider_setting
            ? data.third_party_rider_setting.hl_storebased_token
            : '';
        defaultValue.hl_storebased_store_code = data.third_party_rider_setting
            ? data.third_party_rider_setting.hl_storebased_store_code
            : '';
        defaultValue.is_coid = data.third_party_rider_setting ? data.third_party_rider_setting.is_COID : '';
        defaultValue.is_hlbackend_integration_enabled = data.third_party_rider_setting?.is_hlbackend_integration_enabled
            ? data.third_party_rider_setting.is_hlbackend_integration_enabled
                ? 1
                : 0
            : 0;
        defaultValue.use_global_hl_store_based_configurations =
            data?.third_party_rider_setting?.use_global_hl_store_based_configurations;

        // Adlogs sub-aggregator integration flags
        defaultValue.is_adlogs_blitz_integration_enabled = data.third_party_rider_setting
            ? data.third_party_rider_setting?.is_adlogs_blitz_integration_enabled
                ? 1
                : 0
            : 0;
        defaultValue.is_adlogs_borzo_integration_enabled = data.third_party_rider_setting
            ? data.third_party_rider_setting?.is_adlogs_borzo_integration_enabled
                ? 1
                : 0
            : 0;
        defaultValue.is_adlogs_ek_bharat_integration_enabled = data.third_party_rider_setting
            ? data.third_party_rider_setting?.is_adlogs_ek_bharat_integration_enabled
                ? 1
                : 0
            : 0;
        defaultValue.is_adlogs_load_share_integration_enabled = data.third_party_rider_setting
            ? data.third_party_rider_setting?.is_adlogs_load_share_integration_enabled
                ? 1
                : 0
            : 0;
        defaultValue.is_adlogs_magicpin_integration_enabled = data.third_party_rider_setting
            ? data.third_party_rider_setting?.is_adlogs_magicpin_integration_enabled
                ? 1
                : 0
            : 0;
        defaultValue.is_adlogs_ondc_integration_enabled = data.third_party_rider_setting
            ? data.third_party_rider_setting?.is_adlogs_ondc_integration_enabled
                ? 1
                : 0
            : 0;
        defaultValue.is_adlogs_qwqer_integration_enabled = data.third_party_rider_setting
            ? data.third_party_rider_setting?.is_adlogs_qwqer_integration_enabled
                ? 1
                : 0
            : 0;
        defaultValue.is_adlogs_rapido_integration_enabled = data.third_party_rider_setting
            ? data.third_party_rider_setting?.is_adlogs_rapido_integration_enabled
                ? 1
                : 0
            : 0;
        defaultValue.is_adlogs_shadowfax_integration_enabled = data.third_party_rider_setting
            ? data.third_party_rider_setting?.is_adlogs_shadowfax_integration_enabled
                ? 1
                : 0
            : 0;
        defaultValue.is_adlogs_ship_rocket_integration_enabled = data.third_party_rider_setting
            ? data.third_party_rider_setting?.is_adlogs_ship_rocket_integration_enabled
                ? 1
                : 0
            : 0;
        defaultValue.is_adlogs_yullu_integration_enabled = data.third_party_rider_setting
            ? data.third_party_rider_setting?.is_adlogs_yullu_integration_enabled
                ? 1
                : 0
            : 0;
        // Shadow fax rider info
        defaultValue.shadowfax_token = data.third_party_rider_setting
            ? data.third_party_rider_setting.shadowfax_token
            : '';

        defaultValue.shadowfax_client_code = data.third_party_rider_setting
            ? data.third_party_rider_setting.shadowfax_client_code
            : '';

        defaultValue.is_shadowfax_integration_enabled = data.third_party_rider_setting
            ? parseInt(data.third_party_rider_setting.is_shadowfax_integration_enabled)
                ? 1
                : 0
            : 0;

        defaultValue.use_global_shadowfax_configurations =
            data?.third_party_rider_setting?.use_global_shadowfax_configurations;
        defaultValue.use_global_wefast_configurations =
            data?.third_party_rider_setting?.use_global_wefast_configurations;
        defaultValue.use_global_dunzo_configurations = data?.third_party_rider_setting?.use_global_dunzo_configurations;

        return defaultValue;
    }, []);

    const { defaultValues, setDefaultValues, onSuccessCallback } = useOutletFormValues({ updateFormValues });

    const onFormSaveApi = useCallback(
        async (data) => {
            if (data.use_global_dunzo_configurations) {
                delete data.dunzo_integration_available;
            }
            if (data.use_global_hl_store_based_configurations) {
                delete data.is_hlbackend_integration_enabled;
            }
            if (data.use_global_flash_configurations) {
                delete data.is_flash_integration_enabled;
            }
            if (data.use_global_shadowfax_configurations) {
                delete data.is_shadowfax_integration_enabled;
            }

            if (data.use_global_wefast_configurations) {
                delete data.wefast_integration_available;
            }

            if (!data.is_shadowfax_integration_enabled && !data.use_global_shadowfax_configurations) {
                data.shadowfax_token = null;
                data.shadowfax_client_code = null;
            }

            if (!data.is_hlbackend_integration_enabled && !data.use_global_hl_store_based_configurations) {
                data.shadowfax_token = null;
                data.shadowfax_client_code = null;
            }

            if (!data.is_flash_integration_enabled && !data.use_global_flash_configurations) {
                data.flash_token = null;
                data.flash_credits_key = null;
                data.flash_store_brand_id = null;
            }

            if (!data.wefast_integration_available && !data.use_global_wefast_configurations) {
                data.wefast_auth_token = null;
                data.wefast_call_back_url = null;
            }

            if (!data.dunzo_integration_available && !data.use_global_dunzo_configurations) {
                data.dunzo_client_secret = null;
                data.dunzo_client_id = null;
                data.dunzo_call_back_url = null;
            }

            const response = await dispatch(outletSettingsAPI('rider_settings', data));
            if (response.success) setDefaultValues(updateFormValues(response.outlet));
            return response;
        },
        [dispatch, updateFormValues]
    );

    const { errors, control, watch, setValue, reset, isDirty } = useFormActionsHandler({
        onFormSaveApi,
        defaultValues,
        onSuccessCallback,
    });

    const methods = {
        watch,
        control,
        setValue,
        reset,
        formState: {
            errors,
            isDirty,
        },
    };

    return (
        <FormProvider {...methods}>
            <EuiFlexGroup direction='column'>
                <EuiFlexItem>
                    <FormGroupDescription
                        title={restaurantDescriptions?.in_house_riders?.display_name}
                        description={restaurantDescriptions?.in_house_riders?.description}
                    >
                        <ButtonGroup
                            idSelected={watch('enable_own_rider_service') ? '1' : '0'}
                            color='primary'
                            control={control}
                            setValue={setValue}
                            name='enable_own_rider_service'
                            watch={watch}
                            label={'Enable own rider service'}
                        />
                    </FormGroupDescription>
                </EuiFlexItem>
                <EuiFlexItem>
                    <EltRider />
                </EuiFlexItem>
                <EuiFlexItem>
                    <DunzoRider />
                </EuiFlexItem>
                <EuiFlexItem>
                    <WeFastRider />
                </EuiFlexItem>
                <EuiFlexItem>
                    <PorterRider />
                </EuiFlexItem>
                <EuiFlexItem>
                    <ShadowFaxRiders />
                </EuiFlexItem>
                <EuiFlexItem>
                    <FlashRider />
                </EuiFlexItem>
                <EuiFlexItem>
                    <BlitzRider />
                </EuiFlexItem>
                <EuiFlexItem>
                    <BorzoRider />
                </EuiFlexItem>
                <EuiFlexItem>
                    <EkBharatRider />
                </EuiFlexItem>
                <EuiFlexItem>
                    <LoadShareRider />
                </EuiFlexItem>
                <EuiFlexItem>
                    <MagicPinRider />
                </EuiFlexItem>
                <EuiFlexItem>
                    <OndcRider />
                </EuiFlexItem>
                <EuiFlexItem>
                    <QwqerRider />
                </EuiFlexItem>
                <EuiFlexItem>
                    <RapidoRider />
                </EuiFlexItem>
                <EuiFlexItem>
                    <AdlogsShadowfaxRider />
                </EuiFlexItem>
                <EuiFlexItem>
                    <ShipRocketRider />
                </EuiFlexItem>
                <EuiFlexItem>
                    <YulluRider />
                </EuiFlexItem>
                <EuiFlexItem>
                    <HLDedicatedRider />
                </EuiFlexItem>
            </EuiFlexGroup>
        </FormProvider>
    );
};

export default ThirdPartyRider;
